import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import AuthLayout from "./component/layout/auth-layout";
import Signup from "./page/signup";
import Login from "./page/Login/login.js";
import Home from "./page/home";
import NotFound from "./page/not-found";
import Loader from "./component/layout/loader";
import ResetPassword from "./page/reset-password";
import AssignmentDashboard from "./page/assignment/assignment-dashboard";
import Assignment from "./page/assignment/assignment";
import Chat from "./page/chat/chat";
import ManageActivity from "./page/activity/overview";
import CreateActivity from "./page/activity/Component/create";
import UpdateActivity from "./page/activity/Component/update";
import ActivityPerformance from "./page/performance/performance";
import Notifications from "./page/notifications";
import Approval from "./page/approval";
import Configuration from "./page/configuration/index";
import CreateConfiguration from "./page/configuration/create";
import ResetPasswordForm from "./page/reset-password-form";
import Verification from "./page/verification.js";
import UpdateConfiguration from "./page/configuration/update";
import ViewConfiguration from "./page/configuration/View";
import Myaccount from "./page/dashboard/myaccount";
import EmailNotifications from "./page/dashboard/EmailNotification";
import MyNotifications from "./page/dashboard/mynotifications";
import ConnectedApps from "./page/dashboard/connectedapps";
import Departments from "./page/dashboard/department/departments";
import Plans from "./page/dashboard/plans";
import Users from "./page/dashboard/User/users";
import AssignmentJob from "./page/assignment/assignment-job";
import EmbeddedAssignment from "./page/assignment/EmbeddedAssignment";
import EmbeddedOverviewDashboad from "./page/overview/EmbeddedOverviewDashboad";
import RequestOverview from "./page/request/RequestOverview";
import EmbeddedActivityPerformance from "./page/performance/EmbeddedActivityPerformance";
import CallSchedule from "./page/call-schedule";
import Booking from "./page/booking/booking";
import Create from "./page/booking/create";
import Design from "./page/bookingtemplate/design";
import Update from "./page/booking/update";
import CreateAndUpdateTemplate from "./component/ReusableComponent/CreateAndUpdateTemplate";
// import CreateDesign from "./page/bookingtemplate/createDesign";
// import UpdateDesign from "./page/bookingtemplate/updateDesign";
import Insights from "./page/insights/insights";
// import EmbeddedChat from "./page/chat/embedded/chat";
import AssetType from "./page/dashboard/assets/assetType";
import UserVerification from "./page/user_verification";
import { ShareActivityTemplate } from "./page/performance/components/shareActivityTemplate";
import Onboading from "./page/Onboarding/Onboarding";
import IntegrationBooking from "./page/booking/integrationbooking";
import BillingPlans from "./page/dashboard/billingplans/billingplans";
import BillingDetails from "./page/dashboard/billingplans/billingdetails";
import Invoice from "./page/Invoice/Invoice";
import Access from "./page/AccessDenied/access";
import PerformanceIndex from "./page/ToDoPerformance/performanceIndex";
import ComponentIndex from "./page/Manage Component/ComponentIndex";
import PaymentSuccess from "./page/payment/PaymentSuccess";
import PaymentFail from "./page/payment/PaymentFail";
import AnalyticsIndex from "./page/Analytics/analyticsIndex.js";

// Inventory
import SKUIndex from "./page/SKU Master/SKUIndex.js";
import CreateSKU from "./page/SKU Master/Component/CreateSKU.js";
import UpdateSKU from "./page/SKU Master/Component/UpdateSKU.js";
import InventoryIndex from "./page/Inventory/InventoryIndex.js";

// Product
import ProductIndex from "./page/Product Master/ProductIndex.js";
import CreateProduct from "./page/Product Master/Component/CreateProduct.js";
import UpdateProduct from "./page/Product Master/Component/UpdateProduct.js";

// Order Overview
import OrderIndex from "./page/OrderOverview/OrderIndex.js";
import UpdateSalesOrder from "./page/OrderOverview/Component/Sales/UpdateSalesOrder.js";
import UpdatePurchaseOrder from "./page/OrderOverview/Component/Purchase/UpdatePurchaseOrder.js";
import CreateProductionOrder from "./page/OrderOverview/Component/Production/CreateProductionOrder.js";
import UpdateProductionOrder from "./page/OrderOverview/Component/Production/UpdateProductionOrder.js";
import CreatePurchaseOrderTabs from "./page/OrderOverview/Component/Purchase/CreatePurchaseOrderTabs.js";
import CreateSalesOrderTab from "./page/OrderOverview/Component/Sales/CreateSalesOrderTab.js";

//Customization Page
import CustomizationIndex from "./page/dashboard/Customization/WhiteLabeling.js";

//Sign Url Authenetication
import SignUrlAuth from "./page/SignUrlAuth.js";

// Embedded Todo Performance Screen
import NewEmbeddedTodoPerformanceIndex from "./page/ToDoPerformance/newEmbeddedTodoPerformanceIndex.js";

// New Workflow Screens
import WorkflowIndex from "./page/workflow/index.js";
import WorkflowCreate from "./page/workflow/create.js";
import WorkflowUpdate from "./page/workflow/update.js";

// Stackholder
import Stakeholder from "./page/dashboard/stakeholder/stakeholders.js";

// Order Dashboard
import OrderDashboard from "./page/OrderDashboard/OrderDashboard.js";

// Redux
import { useSelector } from "react-redux";
import AccessToken from "./page/dashboard/accessToken/AccessToken";
import swal from "@sweetalert/with-react";
import EmbeddedPerformanceIndex from "./page/ToDoPerformance/embeddedPerformanceIndex";
import Tracking from "./page/tracking.js";
import PublicAssetTracking from "./page/PublicAssetTracking/PublicAssetTracking.js";
import WorkingHours from "./page/dashboard/workingHours/WorkingHours.js";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const userData = useSelector((state) => state.auth);

  useEffect(() => {
    setUser(userData);
    setLoading(false);
  }, [userData]);

  useEffect(() => {
    window.onpopstate = function () {
      swal?.close();
    };
  }, []);

  if (loading) return <Loader fontSize="100px" full />;
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={<Login user={user} setUser={setUser} />}
        />
        <Route
          path="/signup"
          element={<Signup user={user} setUser={setUser} />}
        />
        <Route
          path="/reset-psw"
          element={<ResetPassword user={user} setUser={setUser} />}
        />
        <Route
          path="/reset-psw/verification"
          element={<ResetPasswordForm user={user} setUser={setUser} />}
        />
        <Route
          path="/verification"
          element={<Verification user={user} setUser={setUser} />}
        />
        <Route
          path="/user/verification"
          element={<UserVerification user={user} setUser={setUser} />}
        />
        {/* <Route
          path="/assignment/assign/embedded/:company_id/:assignment_id"
          element={<EmbeddedAssignment />}
        /> */}
        {/* <Route
          path="/dashboard/embedded/:company_id/:email"
          element={<EmbeddedOverviewDashboad />}
        /> */}
        {/* <Route
          path="/todo/performance/embedded/:company_id/:activity_assignment_id/:email"
          element={<EmbeddedPerformanceIndex />}
        /> */}
        <Route
          path="/payment/success"
          element={<PaymentSuccess />}
        />
        <Route
          path="/payment/cancelled"
          element={<PaymentFail />}
        />
        <Route
          path="/tracking/:activity_assignment_id"
          element={<Tracking />} 
        />
         <Route
          path="/public/:activity_assignment_id"
          element={<PublicAssetTracking />}
        />
        {/* <Route
          path="/activity/performance/embedded/:company_id/:activity_assignment_id/:email"
          element={<EmbeddedPerformanceIndex />}
        /> */}
        <Route
          path="/onboard"
          element={
            user?.type === "super-admin" && user?.is_board_complete && user?.is_payment_complete ? (
              <Access />
            ) : (
              <Onboading />
            )
          }
        />
        {/* <Route
          path="/embedded/chat/:company_id/:email"
          element={<EmbeddedChat />}
        /> */}

        <Route
          path="/booking/design/create"
          element={
            <AuthLayout user={userData} Component={CreateAndUpdateTemplate} />
          }
        />

        <Route
          path="/booking/design/update"
          element={
            <AuthLayout user={userData} Component={CreateAndUpdateTemplate} />
          }
        />

        <Route
          path="/order-dashboard"
          element={
            <AuthLayout user={userData} Component={OrderDashboard} />
          }
        />

        {/*  Sign Url Authentication Route */}

        <Route
          path="/auth/sign_url"
          element={<SignUrlAuth />}
        />

        <Route
          path="/auth/app"
          element={<SignUrlAuth />}
        />

        {/* Todo Performance In Embedded Route */}

        <Route
          path="/embedded/todo/performance/:activity_assignment_id"
          element={
            <NewEmbeddedTodoPerformanceIndex />
          }
          // element={
          //   <AuthLayout user={userData} Component={NewEmbeddedTodoPerformanceIndex} />
          // }
        />

        

        {authenticatedComponents.map((Component, i) => (
          <Route
            key={i}
            path={Component.auth.path}
            element={<AuthLayout user={userData} Component={Component} />}
          />
        ))}
        <Route path="/*" element={<NotFound />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="/denied" element={<Access />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

const authenticatedComponents = [
  Home,
  Myaccount,
  MyNotifications,
  ConnectedApps,
  Plans,
  Departments,
  Users,
  BillingPlans,
  BillingDetails,
  Insights,
  Assignment,
  AssignmentDashboard,
  Chat,
  Booking,
  Design,
  Create,
  IntegrationBooking,
  Update,
  // CreateDesign,
  // UpdateDesign,
  ManageActivity,
  CreateActivity,
  UpdateActivity,
  ActivityPerformance,
  Approval,
  Configuration,
  CreateConfiguration,
  UpdateConfiguration,
  ViewConfiguration,
  AssignmentJob,
  CallSchedule,
  AssetType,
  RequestOverview,
  Invoice,
  EmailNotifications,
  ComponentIndex,
  PerformanceIndex,
  AccessToken,
  AnalyticsIndex,
  SKUIndex,
  CreateSKU,
  UpdateSKU,
  ProductIndex,
  CreateProduct,
  UpdateProduct,
  OrderIndex,
  InventoryIndex,
  CreateSalesOrderTab,
  UpdateSalesOrder,
  CreatePurchaseOrderTabs,
  UpdatePurchaseOrder,
  CreateProductionOrder,
  UpdateProductionOrder,
  CustomizationIndex,
  WorkingHours,
  WorkflowIndex,
  WorkflowCreate,
  WorkflowUpdate,
  Stakeholder
];
